/* eslint-disable new-cap */
import { Box } from '@deity/falcon-ui';
import { mapRecordToArray } from '@deity-io/di-data-basics';
import DropInPanel from 'components/DropInPanel/DropInPanel';
import FoldedPanel from 'components/DropInPanel/FoldedPanel';
import { MappingContext } from 'contexts/MappingContext';
import type { FC } from 'react';
import { useContext } from 'react';
import ReactJson from 'react-json-view';
import EditMappingRelation from './EditMappingRelation/EditMappingRelation';

interface IMappingEditorPanelProps {
  locked?: boolean;
  activePanel?: string;
  onOpenPanel: (panel: string | undefined) => void;
}
const MappingEditorPanel: FC<IMappingEditorPanelProps> = ({ locked, activePanel, onOpenPanel }) => {
  const ctx = useContext(MappingContext);

  const panels = {
    SETTINGS: {
      title: 'Settings',
      icon: 'settings' as const,
      disabled: ctx?.state.selected === undefined,
      component: <EditMappingRelation />
    },
    JSON: {
      title: 'JSON Data',
      icon: 'info' as const,
      component: <ReactJson src={ctx?.state.mappingSchema || {}} name={null} theme="solarized" />
    },
    ERRORS: {
      title: 'Validation',
      icon: 'error' as const,
      component: <ReactJson src={ctx?.state.validationMessages || {}} name={null} theme="solarized" />
    }
  };

  return (
    <>
      <DropInPanel
        isHidden={false} // override the display function
        displayFn={() => activePanel !== undefined && !(activePanel === 'SETTINGS' && !ctx?.state.selected)}
      >
        {activePanel && panels[activePanel].component}
      </DropInPanel>
      <Box
        boxShadow="subtle"
        bg="white"
        style={{
          position: 'absolute',
          right: 0,
          top: 96,
          width: '35px',
          height: 'calc(100vh - 167px',
          zIndex: 200
        }}
      >
        <div style={{ writingMode: 'vertical-lr' }}>
          {mapRecordToArray(panels, (panel, key) => (
            <FoldedPanel key={`panel_${key}`} panel={{ panelKey: key, ...panel }} openPanel={onOpenPanel} />
          ))}
        </div>
      </Box>
    </>
  );
};

export default MappingEditorPanel;
